// src/pages/ContentEditor/components/ActionButtons.js
import React from 'react';
import { Box, Button, CircularProgress, alpha } from '@mui/material';
import { 
  Save as SaveIcon, 
  Cancel as CancelIcon 
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const ActionButtons = ({ isNewContent, saving, unsavedChanges, onCancel, onSave }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        sx={{ 
          color: theme.palette.text.primary, 
          borderColor: alpha(theme.palette.common.white, 0.3),
          '&:hover': {
            borderColor: theme.palette.text.primary,
            backgroundColor: alpha(theme.palette.common.white, 0.05)
          }
        }}
        startIcon={<CancelIcon />}
        onClick={onCancel}
      >
        Cancel
      </Button>
      
      <Button
        variant="contained"
        color="primary"
        startIcon={saving ? <CircularProgress size={24} color="inherit" /> : <SaveIcon />}
        onClick={onSave}
        disabled={saving || (!isNewContent && !unsavedChanges)}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
    </Box>
  );
};

export default ActionButtons;

